export class AppSyncQuery {
  constructor(query = '', variables = {}, authMode = 'AWS_IAM') {
    this.query = query;
    this.variables = variables;
    this.authMode = authMode;
  }
}
